import * as React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { useTranslate } from "hooks";
import { useProductsOverviewActions } from "stores/productsOverviewStore";
import { useAllProducts } from "hooks/productHooks/useAllProducts";
import s from "./ProductListLeftSidebar.module.scss";
import { ProductsNavigation } from "./ProductsNavigation";
import { useProject } from "stores/project";
import type { ProductNode } from "interfaces/product/product.types";

type ProductListLeftSidebarProps = {
  isModalActive?: boolean;
};

export const ProductListLeftSidebar = Scrivito.connect(
  (_props: ProductListLeftSidebarProps) => {
    const translate = useTranslate();
    const { navigateToProductListPage } = useProductsOverviewActions();
    const project = useProject();
    const overviewResetHandler = () => {
      navigateToProductListPage({ projectId: project?.id });
    };

    const allProducts = useAllProducts();

    return (
      <div
        className={cx(
          s.productsNavigation,
          "ps-4 pe-2 bg-gray-700 h-full-exclude-footer",
        )}
      >
        <h3
          className="py-5 m-0 text-white cursor-pointer text-uppercase"
          onClick={overviewResetHandler}
        >
          {translate("PRODUCT_LIST_LEFTSIDEBAR_NAV_TITLE")}
        </h3>
        <div className={s.productsNavigationList}>
          {allProducts.map((product: ProductNode, index) => (
            <ProductsNavigation key={product.key ?? index} product={product} />
          ))}
        </div>
      </div>
    );
  },
);
